import classNames from 'classnames';
import React from 'react';
import { SvgIconName } from './model';
import './index.scss';

interface IProps {
  readonly icon: SvgIconName;
  readonly className?: string;
  readonly width?: number;
  readonly height?: number;
  readonly onClick?: () => void;
}

const DEFAULT_VALUE = '16px';

const getStyle = (value?: number) => {
  if (value) {
    return `${value}px`;
  }
  return DEFAULT_VALUE;
};

export const SvgIcon = (props: IProps) => {
  const style: React.CSSProperties = {
    width: getStyle(props.width),
    height: getStyle(props.height || props.width),
  };

  const className = classNames(
    'svg-icon',
    `svg-${props.icon}`,
    props?.className || ''
  );
  return (
    <span className={className} style={style} onClick={props.onClick}></span>
  );
};
